import { render, staticRenderFns } from "./hotelDetails.vue?vue&type=template&id=39b0d276"
import script from "./hotelDetails.vue?vue&type=script&lang=js"
export * from "./hotelDetails.vue?vue&type=script&lang=js"
import style0 from "./hotelDetails.vue?vue&type=style&index=0&id=39b0d276&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports